type EmptyAccountSwitcherProps = {
  linking: boolean;
  onConnect: () => void;
};

export function EmptyAccountSwitcher({ linking, onConnect }: EmptyAccountSwitcherProps) {
  return (
    <button
      type="button"
      className="account-switcher-add"
      onClick={onConnect}
      disabled={linking}
    >
      {linking ? "Abrindo..." : "+ Conectar conta"}
    </button>
  );
}
